import FuturesEvidencePanel from './FuturesEvidencePanel'

interface Props {
  kind: 'adjust-lot' | 'bank-cost-change' | 'market' | 'local-p' | 'local-s'
}

const viewMeta = {
  'adjust-lot': {
    title: 'Adjust Lot',
    accessLabel: 'Adjustment',
    target: 'frmFuturesMainSubForm -> frmFuturesQryAdjustLot',
    description: 'Adjust lot workflow using the generic Futures subform with New/Edit/Delete actions.',
    actions: ['New', 'Edit', 'Delete'],
    evidence: [
      'form_frmFuturesMainSubForm.txt',
      'form_frmFuturesQryAdjustLot.txt',
      'form_frmFuturesQryAdjustLotAdd.txt',
      'query_FuturesQryAdjustLot.txt',
    ],
    notes: [
      'Delete soft-deletes public_adjust_lot by contract_no.',
      'Edit disables contract_p and contract_s, then prefills the selected contract and adjusted_lot.',
    ],
  },
  'bank-cost-change': {
    title: 'Bank Cost Change',
    accessLabel: 'Bank cost change',
    target: 'frmFuturesMainSubForm -> frmFuturesQryBankCostChange',
    description: 'Bank cost change workflow using the generic Futures subform with New/Edit/Delete actions.',
    actions: ['New', 'Edit', 'Delete'],
    evidence: [
      'form_frmFuturesMainSubForm.txt',
      'form_frmFuturesQryBankCostChange.txt',
      'form_frmFuturesQryBankCostChangeAdd.txt',
      'query_FuturesQryBankCostChange.txt',
    ],
    notes: [
      'Delete soft-deletes public_bank_cost_change by bank_cost_change_id.',
      'Edit disables date, bank, and ex in the add form.',
    ],
  },
  market: {
    title: 'Market',
    accessLabel: 'Market',
    target: 'frmFuturesMainSubFormMarket -> frmFuturesQryMarket',
    description: 'Market list/reference screen. Parent Access form has no active New/Edit/Delete toolbar for this tab.',
    actions: [],
    evidence: [
      'form_frmFuturesMainSubFormMarket.txt',
      'form_frmFuturesQryMarket.txt',
      'form_frmFuturesQryMarketAdd.txt',
      'query_FuturesQryMarket.txt',
    ],
    notes: [
      'Access click handler comments out screen-name switching logic.',
      'Implement edits only after confirming behavior from frmFuturesQryMarketAdd.',
    ],
  },
  'local-p': {
    title: 'Local P',
    accessLabel: 'Local P',
    target: 'frmFuturesMain -> navFuturesLocalP -> frmFuturesQryLocalP',
    description: 'Danh sách futures giá địa phương (purchase) — cùng mục tiêu Access `frmFuturesQryLocalP`.',
    actions: [],
    evidence: ['form_frmFuturesMain.txt', 'form_frmFuturesQryLocalP.txt', 'query_FuturesQryLocalP.txt'],
    notes: ['Access: `navFuturesLocalP_Click` đổi `navFutures.SourceObject` sang `frmFuturesQryLocalP`.'],
  },
  'local-s': {
    title: 'Local S',
    accessLabel: 'Local S',
    target: 'frmFuturesMain -> navFuturesLocalS -> frmFuturesQryLocalS',
    description: 'Danh sách futures giá địa phương (sales) — cùng mục tiêu Access `frmFuturesQryLocalS`.',
    actions: [],
    evidence: ['form_frmFuturesMain.txt', 'form_frmFuturesQryLocalS.txt', 'query_FuturesQryLocalS.txt', 'query_FuturesQryLocalSPrint.txt'],
    notes: ['Access: `navFuturesLocalS_Click` đổi `navFutures.SourceObject` sang `frmFuturesQryLocalS`.'],
  },
} satisfies Record<
  Props['kind'],
  { title: string; accessLabel: string; target: string; description: string; actions: string[]; evidence: string[]; notes: string[] }
>

export default function FuturesGenericListView({ kind }: Props) {
  const meta = viewMeta[kind]

  return (
    <FuturesEvidencePanel
      title={meta.title}
      accessLabel={meta.accessLabel}
      accessTarget={meta.target}
      description={meta.description}
      actions={meta.actions}
      evidence={meta.evidence}
      notes={meta.notes}
    />
  )
}
